module.exports = __webpack_public_path__ + "static/media/header_med.5f3a6c60.png";